import React from 'react';
import isEqual from 'react-fast-compare';

import {LegacyMeasurement} from 'constants/MeasurementConstants';
import {MeasurementType, NewMeasurementForm} from 'samples/MeasurementForm';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {NumericInputChangeEvent} from 'util/Types';

interface Props {
  containedItemId: string;
  containedItemName: string;
  concentration?: LegacyMeasurement;
  containerId: string;
  onChange: (containerId: string, containedItemId: string, concentration: Partial<LegacyMeasurement>) => void;
}

class ContainerContentConcentrationForm extends React.Component<Props> {
  /*
   * Added for performance, as this component is often rendered in large groups.
   * PureRenderMixin only does a shallow equality check. Deep equality is needed b/c `concentration` is an
   * object.
   */
  shouldComponentUpdate(nextProps: Props): boolean {
    return !isEqual(this.props, nextProps);
  }

  _handleValueChange = (e: NumericInputChangeEvent): void => {
    const {containerId, containedItemId} = this.props;
    this.props.onChange(containerId, containedItemId, {value: e.target.numericValue});
  };

  _handleUnitsChange = ({val}: {val: string | null}): void => {
    const {containerId, containedItemId} = this.props;
    this.props.onChange(containerId, containedItemId, {units: val});
  };

  render(): JSX.Element {
    const sharedFormProps = {
      measurement: this.props.concentration,
      onChangeValue: this._handleValueChange,
      onChangeUnits: this._handleUnitsChange,
    };
    return (
      <Row key={this.props.containedItemId}>
        <label className="transferModal-tableForm">
          <Col xs={6}>{this.props.containedItemName}</Col>
          <Col xs={6}>
            <NewMeasurementForm {...sharedFormProps} measurementType={MeasurementType.CONCENTRATION} />
          </Col>
        </label>
      </Row>
    );
  }
}

export default ContainerContentConcentrationForm;
